<template>
	<main>
		<div class="kv"></div>
		<div class="main">
			<div class="img">
				<img :src="require('@/assets/edm/wap/info.png')" alt="">
				<div class="btn" @click="util.toLink('/invitation')"></div>
			</div>
		</div>
	</main>
</template>

<script>
export default {
	name: 'info',
	data() {
		return {

		}
	},
	components:{},
	computed:{

	},
	methods: {

	},
	mounted() {

	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.kv{height:4.32rem;background: url("~@/assets/edm/wap/kv.jpg") no-repeat center center;background-size: cover;}
.main{text-align: center;background: url("~@/assets/edm/wap/bj.jpg") no-repeat top center;background-size: cover;
	.img{position: relative;text-align: center;padding: .25rem .25rem .5rem;
		img{width: 100%;}
		.btn{position: absolute;bottom:2rem;left:50%;transform: translateX(-50%); width: 2rem;height:.6rem;background: url("~@/assets/edm/wap/info_btn.png") no-repeat center center;background-size: contain;cursor: pointer;}
	}
}
</style>

